export default __webpack_public_path__ + "static/char-s-57-ja-599ab7a137f99f4aa060e15e3731b31d.png";